// In-app notification bell for logged-in users.
// Driven by window.sc_notify = { restUrl, nonce } (set via wp_localize_script).
//
// NOTE: this is the bundled twin of the handler currently inlined in
// wp/theme/header.php. The inline copy is what runs in production; keep the
// two behaviours in sync. To switch to the bundled module, drop the inline
// <script>/<style> from header.php and re-add the wp_localize_script call in
// inc/notifications.php.

const STYLE = `
.sc-notif-wrap { position:relative; display:inline-block; margin-right:8px; vertical-align:middle; }
.sc-notif-btn { display:inline-flex; background:transparent; border:1px solid rgba(255,255,255,0.18); color:#e6e6e6; border-radius:6px; height:38px; width:42px; align-items:center; justify-content:center; cursor:pointer; padding:0; transition: background 0.15s, border-color 0.15s; position:relative; }
.sc-notif-btn:hover { background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.3); }
.sc-notif-svg { width:18px; height:18px; pointer-events:none; display:block; }
.sc-notif-badge { position:absolute; top:-5px; right:-5px; background:#e15858; color:#fff; border-radius:10px; font-size:10px; line-height:1; padding:3px 5px; font-weight:700; min-width:18px; text-align:center; box-shadow:0 0 0 2px #1d1d1d; pointer-events:none; }
.sc-notif-panel { position:absolute; top:calc(100% + 8px); right:0; width:340px; max-height:480px; overflow-y:auto; background:#1f1f1f; border:1px solid rgba(255,255,255,0.1); border-radius:8px; box-shadow:0 10px 30px rgba(0,0,0,0.45); z-index:1080; display:none; }
.sc-notif-panel.open { display:block; }
.sc-notif-head { padding:12px 16px; border-bottom:1px solid rgba(255,255,255,0.08); color:#fff; font-weight:600; font-size:14px; display:flex; justify-content:space-between; align-items:center; gap:10px; }
.sc-notif-head .sc-notif-allread { font-weight:400; font-size:12px; color:#7eb6ff; text-decoration:none; white-space:nowrap; cursor:pointer; }
.sc-notif-head .sc-notif-allread:hover { text-decoration:underline; }
.sc-notif-empty { padding:24px 16px; color:#9b9b9b; text-align:center; font-size:13px; }
.sc-notif-item { padding:12px 16px; border-bottom:1px solid rgba(255,255,255,0.06); color:#e6e6e6; font-size:13px; line-height:1.45; }
.sc-notif-item:last-child { border-bottom:none; }
.sc-notif-item.is-read { opacity:0.5; }
.sc-notif-item .t { font-weight:600; color:#fff; margin-bottom:4px; }
.sc-notif-item .b { color:#cfcfcf; word-wrap:break-word; }
.sc-notif-item .b a { color:#7eb6ff; }
.sc-notif-item .b p { margin: 0 0 6px 0; }
.sc-notif-item .b p:last-child { margin-bottom: 0; }
.sc-notif-item .cta { display:inline-block; margin-top:8px; margin-right:8px; padding:6px 12px; background:#c9a000; color:#1a1a1a; border-radius:4px; text-decoration:none; font-size:12px; font-weight:600; }
.sc-notif-item .cta:hover { background:#dab500; color:#1a1a1a; text-decoration:none; }
.sc-notif-dismiss { margin-top:8px; display:inline-block; padding:5px 11px; background:transparent; border:1px solid rgba(255,255,255,0.22); color:#cfcfcf; border-radius:4px; font-size:12px; line-height:1.4; cursor:pointer; font-family:inherit; }
.sc-notif-dismiss:hover { background:rgba(255,255,255,0.08); color:#fff; border-color:rgba(255,255,255,0.4); }
.sc-notif-meta { margin-top:6px; font-size:11px; color:#8a8a8a; }
.sc-notif-earlier-toggle { padding:10px 16px; border-top:1px solid rgba(255,255,255,0.08); }
.sc-notif-earlier { color:#9b9b9b; font-size:12px; text-decoration:none; cursor:pointer; }
.sc-notif-earlier:hover { color:#cfcfcf; text-decoration:underline; }
@media (max-width: 991px) { .sc-notif-btn.d-none.d-lg-inline-flex { display:none !important; } }
@media (max-width: 575px) { .sc-notif-panel { width: 92vw; right: -8px; } }
`;

function injectStyle() {
    if (document.getElementById('sc-notif-style')) return;
    const s = document.createElement('style');
    s.id = 'sc-notif-style';
    s.textContent = STYLE;
    document.head.appendChild(s);
}

function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
}

export default function setupNotifications() {
    if (!window.sc_notify) return;
    injectStyle();

    const btn = document.getElementById('sc-notif-btn');
    const panel = document.getElementById('sc-notif-panel');
    const wrap = document.getElementById('sc-notif-wrap');
    if (!btn || !panel || !wrap) return;
    btn.style.display = '';

    const REST = window.sc_notify.restUrl;
    const NONCE = window.sc_notify.nonce;
    let all = [];           // [{ id, title, body_html, cta_url, cta_label, created_at, read }]
    let open = false;
    let loadedAll = false;  // true once we've fetched include_read
    let showEarlier = false;

    const unreadCount = () => all.filter(it => !it.read).length;

    function setBadge(n) {
        let b = btn.querySelector('.sc-notif-badge');
        if (n > 0) {
            if (!b) { b = document.createElement('span'); b.className = 'sc-notif-badge'; btn.appendChild(b); }
            b.textContent = n > 9 ? '9+' : String(n);
        } else if (b) {
            b.remove();
        }
    }

    function api(path, opts = {}) {
        opts.credentials = 'same-origin';
        opts.headers = { ...(opts.headers || {}), 'X-WP-Nonce': NONCE };
        return fetch(REST + (path || ''), opts);
    }

    function itemHtml(it) {
        const cta = it.cta_url
            ? `<a class="cta" href="${escapeHtml(it.cta_url)}" rel="noopener">${escapeHtml(it.cta_label || 'Open')}</a>`
            : '';
        const foot = it.read
            ? `<div class="sc-notif-meta">${escapeHtml(String(it.created_at || '').slice(0, 10))}</div>`
            : `<button type="button" class="sc-notif-dismiss" data-nid="${it.id}">Dismiss</button>`;
        return `<div class="sc-notif-item${it.read ? ' is-read' : ''}" data-nid="${it.id}">`
            + `<div class="t">${escapeHtml(it.title)}</div>`
            + `<div class="b">${it.body_html || ''}</div>`
            + cta + foot + `</div>`;
    }

    function render() {
        const unread = all.filter(it => !it.read);
        const read = all.filter(it => it.read);
        const head = `<div class="sc-notif-head"><span>Notifications${unread.length ? ` (${unread.length} new)` : ''}</span>`
            + (unread.length ? `<a href="#" class="sc-notif-allread">Mark all read</a>` : '') + `</div>`;
        let body;
        if (!unread.length && !read.length) {
            body = `<div class="sc-notif-empty">You're all caught up</div>`;
        } else {
            body = unread.length ? unread.map(itemHtml).join('') : `<div class="sc-notif-empty">No new notifications</div>`;
            if (loadedAll) {
                if (read.length) {
                    body += `<div class="sc-notif-earlier-toggle"><a href="#" class="sc-notif-earlier">`
                        + (showEarlier ? '▾ Hide earlier' : `▸ Show earlier (${read.length})`) + `</a></div>`;
                    if (showEarlier) body += read.map(itemHtml).join('');
                }
            } else {
                body += `<div class="sc-notif-earlier-toggle"><a href="#" class="sc-notif-earlier">▸ Show earlier</a></div>`;
            }
        }
        panel.innerHTML = head + body;
    }

    function loadUnread() {
        return api().then(r => (r.ok ? r.json() : { items: [] })).then(d => (d && d.items) || []).catch(() => []);
    }
    function loadAll() {
        return api('?include_read=1').then(r => (r.ok ? r.json() : { items: [] })).then(d => (d && d.items) || []).catch(() => []);
    }
    function dismiss(id) {
        return api(`/${id}/read`, { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(r => { if (r.ok) { const it = all.find(x => x.id === id); if (it) it.read = true; } })
            .catch(() => {});
    }

    function openPanel() {
        open = true;
        panel.classList.add('open');
        panel.style.display = 'block';
        render();
        if (!loadedAll) {
            loadAll().then(items => { all = items.slice(); loadedAll = true; setBadge(unreadCount()); render(); });
        }
    }
    function closePanel() {
        open = false;
        panel.classList.remove('open');
        panel.style.display = 'none';
    }

    btn.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); open ? closePanel() : openPanel(); });
    panel.addEventListener('click', e => {
        const d = e.target.closest && e.target.closest('.sc-notif-dismiss');
        if (d) {
            e.preventDefault();
            const id = parseInt(d.getAttribute('data-nid'), 10);
            dismiss(id).then(() => { setBadge(unreadCount()); render(); });
            return;
        }
        const a = e.target.closest && e.target.closest('.sc-notif-allread');
        if (a) {
            e.preventDefault();
            const ids = all.filter(x => !x.read).map(x => x.id);
            Promise.all(ids.map(dismiss)).then(() => { setBadge(unreadCount()); render(); });
            return;
        }
        const er = e.target.closest && e.target.closest('.sc-notif-earlier');
        if (er) {
            e.preventDefault();
            if (!loadedAll) {
                loadAll().then(items => { all = items.slice(); loadedAll = true; showEarlier = true; setBadge(unreadCount()); render(); });
            } else {
                showEarlier = !showEarlier;
                render();
            }
            return;
        }
    });
    document.addEventListener('click', e => { if (open && !panel.contains(e.target) && !btn.contains(e.target)) closePanel(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && open) closePanel(); });

    loadUnread().then(items => { all = items.slice(); loadedAll = false; setBadge(items.length); if (open) render(); });
}
